var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIconFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0274 7.05411H6.1696V11.1082C6.1696 11.3232 6.08831 11.5294 5.94362 11.6815C5.79892 11.8336 5.60267 11.919 5.39804 11.919C5.19341 11.919 4.99715 11.8336 4.85246 11.6815C4.70776 11.5294 4.62647 11.3232 4.62647 11.1082V7.05411H0.768637C0.564005 7.05411 0.367754 6.96869 0.223057 6.81663C0.0783603 6.66458 -0.00292969 6.45834 -0.00292969 6.2433C-0.00292969 6.02826 0.0783603 5.82203 0.223057 5.66997C0.367754 5.51792 0.564005 5.43249 0.768637 5.43249H4.62647V1.37844C4.62647 1.1634 4.70776 0.957164 4.85246 0.805108C4.99715 0.653051 5.19341 0.567627 5.39804 0.567627C5.60267 0.567627 5.79892 0.653051 5.94362 0.805108C6.08831 0.957164 6.1696 1.1634 6.1696 1.37844V5.43249H10.0274C10.2321 5.43249 10.4283 5.51792 10.573 5.66997C10.7177 5.82203 10.799 6.02826 10.799 6.2433C10.799 6.45834 10.7177 6.66458 10.573 6.81663C10.4283 6.96869 10.2321 7.05411 10.0274 7.05411Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconFilters);
export default __webpack_public_path__ + "static/media/add-icon-filters.ff50436349dd060213f2300543b00dd7.svg";
export { ForwardRef as ReactComponent };